require([
    'services',
    'jquery',
    'semantic',
    'ch_category_preferences',
    'sweetalert',
    'ch_semantic_responsive',
    'ch_header'
], function() {

    function thanksSwal() {
        swal({
            title: "Thank you!",
            text: "Enter \"IDNYC15\" at checkout to get 15% off your class purchase. We've emailed you the code for future reference.",
            type: "success",
            confirmButtonText: 'View All Classes'
        }, function() {
            window.location.href = '/nyc/classes';
        });
    }

    function initFormHandlers() {
        $.fn.form.settings.rules.idnycFormat = function(value) {
            return value.indexOf('1624') == 0;
        };

        $idnycForm = $('.idnyc-container form');

        $idnycForm.form({
            fields: {
                email: {
                    identifier: 'email',
                    rules: [
                        {
                            type: 'empty',
                            prompt: 'This field is required.'
                        },
                        {
                            type: 'email',
                            prompt: 'Please enter a valid email.'
                        }
                    ]
                },
                idnyc_number: {
                    identifier: 'idnyc_number',
                    rules: [
                        {
                            type: 'idnycFormat',
                            prompt: "That doesn't look like a IDNYC number. Please <a href='/contact-us'>contact our support team</a> to sign up."
                        },
                        {
                            type: 'exactLength[14]',
                            prompt: 'IDNYC account numbers are 14 digits long.'
                        }
                    ]
                }
            },
            onSuccess: function(e) {
                e.preventDefault();

                $idnycForm.addClass('loading');

                $.ajax({
                    url: $idnycForm.attr('action'),
                    type: 'POST',
                    data: $idnycForm.serialize(),
                    xhrFields: {
                        withCredentials: true
                    },
                    success: function (res) {
                        $idnycForm.removeClass('loading');
                        if (!res.success && res.error) {
                            swal('There was a problem!', res.error, 'error');
                            return;
                        }

                        if (!CH.getCookie('ch_cp')) {
                            swal({
                                title: 'Almost there!',
                                text: "Tell us what you're interested in. We'll include personalized class recommendations" +
                                    ' with your promo code. <div>' +
                                    '<div class="sa-confirm-button-container">' +
                                        '<button class="confirm" tabindex="1" style="display: inline-block; background-color: rgb(255, 77, 77); box-shadow: rgba(255, 77, 77, 0.8) 0px 0px 2px, rgba(0, 0, 0, 0.0470588) 0px 0px 0px 1px inset;">Select interests</button><div class="la-ball-fall">' +
                                        '</div>' +
                                    '</div>' +
                                    '<button class="cancel" style="border:none; color:#398fd1; font-size: 14px; margin-top: 0;" tabindex="2">No thanks, just send me my promo code.</button>' +
                                '</div>',
                                type: 'success',
                                html: true,
                                customClass: 'interest-modal',
                                showCancelButton: false,
                                closeOnCancel: false,
                                confirmButtonText: 'View All Classes'
                            },
                            function(isConfirm) {
                                if (isConfirm) {
                                    CH.showCategoryPreferencesWindow();
                                } else {
                                    thanksSwal();
                                }
                            });
                        } else {
                            thanksSwal();
                        }
                    }
                });
            }
        });
    }

    CH.preferenceSuccessCallback = function() {
        thanksSwal();
    };

    $(function() {
        initFormHandlers();
    });

});
